import {Iso8601} from '@hconnect/common/types'
import {shouldNotBeEmpty, Validator} from '@hconnect/common/validators'
import moment from 'moment'

import {InstructionType, DocumentUpdate} from '../types/documents.types'

// Anchored: host restricted to letters/digits/dots/hyphens; '@' only allowed in path/query
const PROTOCOL_LESS_URL_REGEX =
  /^(www\.)?[a-zA-Z0-9](?:[a-zA-Z0-9.-]*[a-zA-Z0-9])?\.([a-z]{2,256})\b(?:[/?#][-a-zA-Z0-9@:%_+.~#?&/=]*)?$/

/**
 * Validates that a hostname parsed by the URL API is a legitimate host:
 * - At least 2 characters (rejects single-char junk like `http://a`)
 * - Only letters, digits, hyphens and dots (rejects garbage like `http://!!!`)
 */
const isValidParsedHostname = (hostname: string): boolean => {
  if (hostname.length < 2) return false
  return /^[a-zA-Z0-9]([a-zA-Z0-9\-.]*[a-zA-Z0-9])?$/.test(hostname)
}

const isValidLink = (value: string): boolean => {
  if (/^https?:\/\//i.test(value)) {
    try {
      const url = new URL(value)
      // Reject embedded credentials (http://user:pass@host)
      if (url.username || url.password) return false
      return isValidParsedHostname(url.hostname)
    } catch {
      return false
    }
  }
  return PROTOCOL_LESS_URL_REGEX.test(value)
}

export const validToValidator: Validator<DocumentUpdate> = (
  date: Iso8601 | undefined,
  item: Partial<DocumentUpdate>
) => {
  if (date) {
    return moment(date).isAfter(item.validFrom) ? undefined : 'shouldBe.dateAfter'
  }
  return undefined
}

export const shouldNotBeEmptyLinkValidator: Validator<DocumentUpdate> = (
  value: string,
  item: Partial<DocumentUpdate>
) => {
  if (item.type === InstructionType.LINK) {
    const emptyError = shouldNotBeEmpty()(value, item)
    if (emptyError) {
      return emptyError
    }
    if (!isValidLink(value)) {
      return 'shouldBe.validUrl'
    }
  }
}

export const shouldNotBeEmptyAttachmentValidator: Validator<DocumentUpdate> = (
  value: string,
  item: Partial<DocumentUpdate>
) => {
  if (item.type === InstructionType.PDF && !item.attachment) {
    return shouldNotBeEmpty()(value, item)
  }
}
